import { DS_BREAKPOINT } from '@calm/evexia-design-tokens';
import { useIsMobile } from '@rhg/hooks/use-is-mobile';
import { Box, Button, ButtonProps, SxProps, Theme } from '@rhg/libs/material';
import { sxAppend } from '@rhg/libs/material/sx';

export const BOTTOM_ACTION_SECTION_HEIGHT_DESKTOP = 72;
export const BOTTOM_ACTION_SECTION_HEIGHT_MOBILE = 64;

const styleBar = {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    py: 1,
    display: 'flex',
    justifyContent: 'center',
    height: {
        xs: BOTTOM_ACTION_SECTION_HEIGHT_MOBILE,
        sm: BOTTOM_ACTION_SECTION_HEIGHT_MOBILE,
        md: BOTTOM_ACTION_SECTION_HEIGHT_DESKTOP,
        lg: BOTTOM_ACTION_SECTION_HEIGHT_DESKTOP,
    },
    px: (theme: Theme) => ({
        sm: theme.ds.spacingUnits.SIDE_SMALL,
        md: theme.ds.spacingUnits.SIDE_MEDIUM,
        lg: theme.ds.spacingUnits.SIDE_LARGE,
    }),
    backgroundColor: (theme: Theme) =>
        theme.palette.mode === 'light'
            ? 'background.paper'
            : 'background.primary',
    borderTop: (theme: Theme) =>
        theme.palette.mode === 'light'
            ? `1px solid ${theme.palette.divider}`
            : 'none',
};

const styleButtonsContainer = {
    width: '100%',
    maxWidth: DS_BREAKPOINT.MEDIUM,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: { xs: 'column-reverse', sm: 'column-reverse', md: 'row' },
};

const styleButton = {
    width: '100%',
    maxWidth: { xs: '100%', sm: '100%', md: DS_BREAKPOINT.MEDIUM },
    mx: { xs: 0, sm: 0, md: 2 },
    my: 2,
};

interface BottomActionProps extends ButtonProps {
    label: string;
    /** Overrides the bar's background/border, e.g. for a gradient bar. */
    barSx?: SxProps<Theme>;
}

export function BottomAction({
    label,
    barSx,
    ...buttonProps
}: BottomActionProps) {
    const isMobile = useIsMobile('md');

    return (
        <Box sx={sxAppend(styleBar, barSx)}>
            <Box sx={styleButtonsContainer}>
                <Button
                    size={isMobile ? 'medium' : 'large'}
                    {...buttonProps}
                    sx={sxAppend(styleButton, buttonProps.sx)}
                >
                    {label}
                </Button>
            </Box>
        </Box>
    );
}
